/* Kryptonaut theme — progressive enhancement only. Everything below degrades
   to a working, server-rendered page when JS is unavailable. */
(function () {
  'use strict';

  var STORAGE_KEY = 'kryptonaut:theme';

  /* ---------- Colour scheme toggle ---------- */
  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function applyTheme(value) {
    document.documentElement.setAttribute('data-theme', value);
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(value === 'light'));
    });
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* private mode */ }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-theme-toggle]');
    if (!toggle) return;
    event.preventDefault();
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  });

  /* ---------- Mobile navigation ---------- */
  function closeMobileNav() {
    document.querySelectorAll('[data-nav-toggle]').forEach(function (burger) {
      var panel = document.getElementById(burger.getAttribute('aria-controls'));
      if (panel) panel.removeAttribute('open');
      burger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var burger = event.target.closest('[data-nav-toggle]');
    if (!burger) return;
    var panel = document.getElementById(burger.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.hasAttribute('open');
    if (open) { panel.removeAttribute('open'); } else { panel.setAttribute('open', ''); }
    burger.setAttribute('aria-expanded', String(!open));
  });

  /* ---------- In-page anchors ---------- */
  /* Links such as "Mitgliedschaften" or "Kostenlos starten" point at #pakete
     on the home page. When that section is already on screen we scroll to it
     instead of letting the browser re-navigate, close the mobile panel first
     and still keep the hash in the address bar. */
  var smoothSupported = 'scrollBehavior' in document.documentElement.style;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* The scroll position that puts the element right below the sticky header,
     clamped to what the document can actually scroll to. */
  function anchorTop(el) {
    var margin = parseFloat(window.getComputedStyle(el).scrollMarginTop) || 0;
    var wanted = window.pageYOffset + el.getBoundingClientRect().top - margin;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    return Math.min(Math.max(0, wanted), max);
  }

  /* Web fonts, images and embeds above the target finish loading while the
     smooth scroll is still running, which moves the section further down and
     leaves the page stranded above it. So: scroll, wait until the page stops
     moving, then close whatever gap is left.

     The visitor always wins: any scroll of their own ends the correction, so
     it can never pull them back to the section afterwards. */
  var CORRECTION_ABORT_EVENTS = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
  var correctionTimer = null;

  function stopCorrection() {
    if (correctionTimer) {
      window.clearInterval(correctionTimer);
      correctionTimer = null;
    }
    CORRECTION_ABORT_EVENTS.forEach(function (type) {
      window.removeEventListener(type, stopCorrection);
    });
  }

  function correctAnchor(el, attempt) {
    stopCorrection();
    if (attempt > 3) return;

    CORRECTION_ABORT_EVENTS.forEach(function (type) {
      window.addEventListener(type, stopCorrection, { passive: true });
    });

    var previous = null;
    var settled = 0;
    var ticks = 0;
    correctionTimer = window.setInterval(function () {
      var y = Math.round(window.pageYOffset);
      settled = y === previous ? settled + 1 : 0;
      previous = y;
      ticks += 1;

      /* Still moving — keep waiting, but never longer than ~2.5s. */
      if (settled < 2 && ticks < 25) return;

      var reachedRest = settled >= 2;
      stopCorrection();

      /* Only nudge from a position the browser's own animation came to rest
         at. A timeout means something else is moving the page — leave it. */
      if (reachedRest && Math.abs(anchorTop(el) - window.pageYOffset) > 2) {
        window.scrollTo({ top: anchorTop(el), behavior: 'smooth' });
        correctAnchor(el, attempt + 1);
      }
    }, 100);
  }

  function scrollToAnchor(el) {
    var top = anchorTop(el);
    stopCorrection();

    if (prefersReducedMotion() || !smoothSupported) {
      window.scrollTo(0, top);
      return;
    }

    window.scrollTo({ top: top, behavior: 'smooth' });
    correctAnchor(el, 1);
  }

  function anchorTarget(hash) {
    if (!hash || hash.length < 2) return null;
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return null; }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

    var url;
    try { url = new URL(link.href, window.location.href); } catch (e) { return; }
    if (url.origin !== window.location.origin) return;
    if (url.pathname !== window.location.pathname) return;

    var target = anchorTarget(url.hash);
    if (!target) return;

    /* The hash deliberately stays out of the address bar: with "#pakete" in
       the URL every reload would jump straight back to the section. */
    event.preventDefault();
    closeMobileNav();
    scrollToAnchor(target);
  });

  /* Arriving with a hash from another page hits the same late layout shifts,
     and there the browser has already jumped — correct it once everything has
     loaded, unless the visitor has taken over scrolling in the meantime. */
  (function () {
    var target = anchorTarget(window.location.hash);
    if (!target) return;

    var takenOver = false;
    function release() { takenOver = true; }
    CORRECTION_ABORT_EVENTS.forEach(function (type) {
      window.addEventListener(type, release, { passive: true, once: true });
    });

    window.addEventListener('load', function () {
      if (!takenOver && Math.abs(anchorTop(target) - window.pageYOffset) > 2) {
        window.scrollTo(0, anchorTop(target));
      }
      /* Hash consumed — drop it, so reloading the page does not jump again. */
      if (window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    });
  })();

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = String(Math.max(min, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart: withdrawal consent ---------- */
  /* The checkbox stays `required`, so the browser still blocks the checkout.
     Only its bubble is swapped for our own message: iOS Safari truncates it to
     "Dieses Feld markie…". `invalid` does not bubble, hence the capture phase. */
  document.addEventListener('invalid', function (event) {
    var box = event.target;
    if (!box.matches || !box.matches('[data-consent]')) return;
    event.preventDefault();
    var error = document.getElementById(box.getAttribute('aria-describedby'));
    if (error) error.hidden = false;
    box.closest('.k-consent').classList.add('k-consent--invalid');
    box.focus({ preventScroll: true });
    box.closest('.k-consent').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  document.addEventListener('change', function (event) {
    var box = event.target;
    if (!box.matches('[data-consent]') || !box.checked) return;
    var error = document.getElementById(box.getAttribute('aria-describedby'));
    if (error) error.hidden = true;
    box.closest('.k-consent').classList.remove('k-consent--invalid');
  });

  /* ---------- Product: variant and purchase option selection ---------- */
  /* Reads the variant JSON Liquid rendered into the page and keeps the hidden
     `id` input, the hidden `selling_plan` input, the price and the submit
     button in sync. No API calls.

     A subscription app such as Appstle can own the plan picker instead of the
     theme's. It writes into the same `selling_plan` input, so the input — not
     our radios — is treated as the source of truth for what is selected. */
  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = root.querySelector('[data-variant-id]');
    if (!idInput) return;

    var priceEl = root.querySelector('[data-variant-price]');
    var compareEl = root.querySelector('[data-variant-compare]');
    var submit = root.querySelector('[data-add-to-cart]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var planInput = root.querySelector('[data-selling-plan-input]');
    var planRadios = Array.prototype.slice.call(root.querySelectorAll('[data-plan-radio]'));
    var form = root.querySelector('form[action*="/cart/add"]') || root;

    /* A product with one variant has no selects — the hidden input is then the
       only thing that names the variant, and it is already correct. */
    function matchVariant() {
      if (selects.length) {
        var chosen = selects.map(function (s) { return s.value; });
        return variants.find(function (v) {
          return chosen.every(function (value, i) { return v.options[i] === value; });
        });
      }
      var current = String(idInput.value);
      return variants.find(function (v) { return String(v.id) === current; }) || variants[0];
    }

    function allocation(variant, planId) {
      if (!variant || !planId) return null;
      return (variant.selling_plan_allocations || {})[planId] || null;
    }

    /* Hides the plans this variant is not sold on, prices the rest, and leaves
       the hidden input naming a plan that the variant actually offers. */
    function syncPlans(variant) {
      planRadios.forEach(function (radio) {
        var item = radio.closest('[data-plan-option]');
        if (!item) return;
        var price = item.querySelector('[data-plan-price]');

        if (!radio.value) {
          if (price) price.innerHTML = variant.price;
          return;
        }

        var alloc = allocation(variant, radio.value);
        radio.disabled = !alloc;
        item.hidden = !alloc;
        if (price) price.innerHTML = alloc ? alloc.price : '';

        var compare = item.querySelector('[data-plan-compare]');
        if (compare) {
          compare.innerHTML = (alloc && alloc.compare_at_price) || '';
          compare.hidden = !(alloc && alloc.compare_at_price);
        }
      });

      if (!planRadios.length) return;

      var checked = planRadios.filter(function (r) { return r.checked && !r.disabled; })[0];
      if (!checked) {
        checked = planRadios.filter(function (r) { return !r.disabled; })[0];
        if (checked) checked.checked = true;
      }
      if (planInput && checked) planInput.value = checked.value;
    }

    /* What the form would really post: an enabled field named selling_plan,
       radios only when checked. Read back to front, because Shopify keeps the
       LAST of repeated fields — verified against /cart/add. Appstle renders
       its options as real radios under that same name, so reading our own
       hidden input would report a plan the visitor never chose. */
    function submittedPlan() {
      var fields = form.querySelectorAll('[name="selling_plan"]');
      for (var i = fields.length - 1; i >= 0; i--) {
        var field = fields[i];
        if (field.disabled) continue;
        if (field.type === 'radio' && !field.checked) continue;
        return field.value;
      }
      return '';
    }

    /* Two fields of one name both get posted and the first wins, which is how
       our fallback used to override every choice made in the app's widget.
       Ours steps aside once the app has put its own field in the form, and
       comes back if the app never loads — so the plan is never just missing,
       and never two. */
    function reconcilePlanFields() {
      if (!planInput) return;
      var fields = form.querySelectorAll('[name="selling_plan"]');
      for (var i = 0; i < fields.length; i++) {
        if (fields[i] !== planInput) {
          planInput.disabled = true;
          return;
        }
      }
      planInput.disabled = false;
    }

    /* The app inserts its widget long after we run. Only a change in how many
       selling_plan fields exist is worth reacting to — our own repaints move
       nodes inside the form too, and reacting to those would loop. */
    var planFieldCount = -1;
    function planFieldsChanged() {
      var count = form.querySelectorAll('[name="selling_plan"]').length;
      if (count === planFieldCount) return false;
      planFieldCount = count;
      return true;
    }

    /* Subscription prices are per plan, not per variant, so the buy box shows
       the allocation whenever a plan is selected. */
    function paint(variant) {
      var alloc = allocation(variant, submittedPlan());
      var price = alloc ? alloc.price : variant.price;
      var compare = alloc ? alloc.compare_at_price : variant.compare_at_price;
      if (priceEl) priceEl.innerHTML = price;
      if (compareEl) {
        compareEl.innerHTML = compare || '';
        compareEl.hidden = !compare;
      }
    }

    function syncUrl(variant) {
      if (!window.history.replaceState || !variant.id) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      var plan = submittedPlan();
      if (plan) {
        url.searchParams.set('selling_plan', plan);
      } else {
        url.searchParams.delete('selling_plan');
      }
      window.history.replaceState({}, '', url.toString());
    }

    function update() {
      reconcilePlanFields();
      var match = matchVariant();

      if (!match) {
        if (submit) {
          submit.setAttribute('disabled', 'disabled');
          submit.textContent = submit.getAttribute('data-unavailable-text') || 'Nicht verfügbar';
        }
        return;
      }

      idInput.value = match.id;
      syncPlans(match);
      paint(match);

      if (submit) {
        if (match.available) {
          submit.removeAttribute('disabled');
          submit.textContent = submit.getAttribute('data-default-text') || submit.textContent;
        } else {
          submit.setAttribute('disabled', 'disabled');
          submit.textContent = submit.getAttribute('data-sold-out-text') || 'Ausverkauft';
        }
      }

      syncUrl(match);

      /* Apps listen for this to re-render their own widget. */
      root.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: match, sellingPlanId: submittedPlan() }
      }));
    }

    selects.forEach(function (s) { s.addEventListener('change', function () { update(); }); });

    planRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (planInput) planInput.value = radio.value;
        update();
      });
    });

    /* Catches the app's own radios as well as ours: they sit in this form and
       their change event bubbles up to it. */
    form.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'selling_plan') update();
    });

    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (planFieldsChanged()) update();
      }).observe(form, { childList: true, subtree: true });
    }

    planFieldsChanged();
    update();
  }

  /* ---------- Product: media thumbnails ---------- */
  function initMedia(root) {
    var main = root.querySelector('[data-media-main]');
    var thumbs = root.querySelectorAll('[data-media-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-media-src');
        main.srcset = thumb.getAttribute('data-media-srcset') || '';
        main.alt = thumb.getAttribute('data-media-alt') || '';
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-product-form]').forEach(initVariantPicker);
    document.querySelectorAll('[data-product-media]').forEach(initMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Sections re-render in the theme editor — re-initialise on each load. */
  document.addEventListener('shopify:section:load', function (event) {
    initVariantPicker(event.target);
    initMedia(event.target);
  });
})();
